import gql from 'graphql-tag';
import { FileFragment } from '@app/pages/cmms/graphql/file.queries';

export const DeleteFile = gql`
	mutation DeleteFile($files: [UUID]!) {
		deleteFiles(files: $files) {
			success
		}
	}
`;

export const EditFileEntityMutation = gql`
	mutation updateFile(
		$pk: UUID!
		$classifications: [String]
		$incidents: [UUID]
		$name: String
		$notes: String
		$requests: [UUID]
		$workOrders: [UUID]
		$locations: [LocationInput]
		$assets: [AssetInput]
		$type: FileEntityTypes
		$labels: [UUID]
	) {
		updateFile(
			pk: $pk
			classifications: $classifications
			incidents: $incidents
			name: $name
			notes: $notes
			requests: $requests
			workOrders: $workOrders
			locations: $locations
			assets: $assets
			type: $type
			labels: $labels
		) {
			file {
				...FileFragment
			}
		}
	}
	${FileFragment}
`;

export const updateFileInsideEntityMutation = gql`
	mutation updateFileInsideEntityMutation(
		$file: Upload!
		$name: String
		$fileEntity: UUID
	) {
		createFile(file: $file, name: $name, fileEntity: $fileEntity) {
			success
		}
	}
`;
//TODO here will be real query when back will done
export const UnlinkFileEntityObjects = gql`
	mutation unlinkFileObjects(
		$pk: UUID!
		$requests: [UUID]
		$incidents: [UUID]
		$workOrders: [UUID]
		$assets: [UUID]
		$classifications: [String]
	) {
		unlinkFileObjects(
			pk: $pk
			requests: $requests
			incidents: $incidents
			workOrders: $workOrders
			assets: $assets
			classifications: $classifications
		) {
			success
		}
	}
`;

export const linkFilesObjectsMutation = gql`
	mutation linkFilesObjectsMutation(
		$files: [UUID]!
		$classifications: [String]
		$incidents: [UUID]
		$locations: [UUID]
		$requests: [UUID]
		$workOrders: [UUID]
		$assets: [AssetInput]
	) {
		linkFilesObjects(
			files: $files
			incidents: $incidents
			requests: $requests
			locations: $locations
			workOrders: $workOrders
			classifications: $classifications
			assets: $assets
		) {
			success
		}
	}
`;

export const updateFiles = gql`
	mutation updateFiles($files: [UUID]!, $type: FileEntityTypes) {
		updateFiles(files: $files, type: $type) {
			success
		}
	}
`;

export const removeClassificationSuggestion = gql`
	mutation ($mappings: [RemoveClassificationSuggestionMapping]!) {
		removeClassificationSuggestions(mappings: $mappings) {
			success
		}
	}
`;
export const startFileClassificationJob = gql`
	mutation startFileClassificationJob($filePks: [UUID]!) {
		startFileClassificationJob(filePks: $filePks) {
			job {
				pk
				processed
				status
				total
			}
			success
		}
	}
`;

export const applyFileTaggingRules = gql`
	mutation applyFileTaggingRules($filePks: [UUID]!) {
		applyFileTaggingRules(filePks: $filePks) {
			success
		}
	}
`;
